
exports.query = function () {
    return $.ajax({ url: "//vip.yy.com/service/web/user/infop", dataType: 'jsonp', jsonpCallback: 'infop' + Date.now() });
};

exports.info = $.ajax({ url: "//vip.yy.com/service/web/user/infop", dataType: 'jsonp' });

exports.logo = $.ajax({ url: "//hd.vip.yy.com/service/hdplatform/user/logop", dataType: 'jsonp' });

/*utilc.dynamicComponentInsert("viplogin_id", '<vip:login $id="viplogin_id"></vip:login>', function(){
   

});

exports.showLogin = function(){
    utilc.asyncGetReadyVMFromId("viplogin_id").then(function(_vm_){
        login.showLogin(_vm_);
    });
};

exports.logout = function(){
    utilc.asyncGetReadyVMFromId("viplogin_id").then(function(_vm_){
        login.logout();
    });
};


*/
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi91c3IvbG9jYWwvc3JjL3ZpcHAtY2xpL2xpYi93ZWJwYWNrL21vZHVsZXMvYmFibGUuanMiXSwibmFtZXMiOlsiZXhwb3J0cyIsInF1ZXJ5IiwiJCIsImFqYXgiLCJ1cmwiLCJkYXRhVHlwZSIsImpzb25wQ2FsbGJhY2siLCJEYXRlIiwibm93IiwiaW5mbyIsImxvZ28iXSwibWFwcGluZ3MiOiI7QUFDQUEsUUFBUUMsS0FBUixHQUFnQixZQUFZO0FBQUMsV0FBT0MsRUFBRUMsSUFBRixDQUFPLEVBQUNDLEtBQUsscUNBQU4sRUFBNkNDLFVBQVUsT0FBdkQsRUFBZ0VDLGVBQWUsVUFBVUMsS0FBS0MsR0FBTCxFQUF6RixFQUFQLENBQVA7QUFBcUgsQ0FBbEo7O0FBRUFSLFFBQVFTLElBQVIsR0FBZVAsRUFBRUMsSUFBRixDQUFPLEVBQUNDLEtBQUsscUNBQU4sRUFBNkNDLFVBQVUsT0FBdkQsRUFBUCxDQUFmOztBQUVBTCxRQUFRVSxJQUFSLEdBQWVSLEVBQUVDLElBQUYsQ0FBTyxFQUFDQyxLQUFLLCtDQUFOLEVBQXVEQyxVQUFVLE9BQWpFLEVBQVAsQ0FBZjs7QUFFQSIsImZpbGUiOiJiYWJsZS5qcyIsInNvdXJjZVJvb3QiOiIvZGF0YS9zZXJ2aWNlcy92aXBtLWhkcGxmbS9zcmNwYWdlcy9oeXNncXlqMTAyOSIsInNvdXJjZXNDb250ZW50IjpbIlxuZXhwb3J0cy5xdWVyeSA9IGZ1bmN0aW9uICgpIHtyZXR1cm4gJC5hamF4KHt1cmw6IFwiLy92aXAueXkuY29tL3NlcnZpY2Uvd2ViL3VzZXIvaW5mb3BcIiwgZGF0YVR5cGU6ICdqc29ucCcsIGpzb25wQ2FsbGJhY2s6ICdpbmZvcCcgKyBEYXRlLm5vdygpfSk7fVxuXG5leHBvcnRzLmluZm8gPSAkLmFqYXgoe3VybDogXCIvL3ZpcC55eS5jb20vc2VydmljZS93ZWIvdXNlci9pbmZvcFwiLCBkYXRhVHlwZTogJ2pzb25wJ30pO1xuXG5leHBvcnRzLmxvZ28gPSAkLmFqYXgoe3VybDogXCIvL2hkLnZpcC55eS5jb20vc2VydmljZS9oZHBsYXRmb3JtL3VzZXIvbG9nb3BcIiwgZGF0YVR5cGU6ICdqc29ucCd9KTtcblxuLyp1dGlsYy5keW5hbWljQ29tcG9uZW50SW5zZXJ0KFwidmlwbG9naW5faWRcIiwgJzx2aXA6bG9naW4gJGlkPVwidmlwbG9naW5faWRcIj48L3ZpcDpsb2dpbj4nLCBmdW5jdGlvbigpe1xuICAgXG5cbn0pO1xuXG5leHBvcnRzLnNob3dMb2dpbiA9IGZ1bmN0aW9uKCl7XG4gICAgdXRpbGMuYXN5bmNHZXRSZWFkeVZNRnJvbUlkKFwidmlwbG9naW5faWRcIikudGhlbihmdW5jdGlvbihfdm1fKXtcbiAgICAgICAgbG9naW4uc2hvd0xvZ2luKF92bV8pO1xuICAgIH0pO1xufTtcblxuZXhwb3J0cy5sb2dvdXQgPSBmdW5jdGlvbigpe1xuICAgIHV0aWxjLmFzeW5jR2V0UmVhZHlWTUZyb21JZChcInZpcGxvZ2luX2lkXCIpLnRoZW4oZnVuY3Rpb24oX3ZtXyl7XG4gICAgICAgIGxvZ2luLmxvZ291dCgpO1xuICAgIH0pO1xufTtcblxuXG4qL1xuIl19


//////////////////
// WEBPACK FOOTER
// /usr/local/src/vipp-cli/web_modules/utils/loginInfo.js
// module id = 11
// module chunks = 0 1